window.closeModal = function (targetModal) {

    MicroModal.close(targetModal);
}